import { render } from "./AppFromGroupSelectable.vue?vue&type=template&id=87d4a792"
import script from "./AppFromGroupSelectable.vue?vue&type=script&lang=js"
export * from "./AppFromGroupSelectable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__